import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('ui.components.PopupErrorBoundary', {
    youCanAlsoClose: 'You can also close this popup and open it again',
    close: 'Close',
});
